import Rails from '@rails/ujs'

const queryString = data => {
  return new URLSearchParams(data).toString()
}

const ajax = async config => {
  return new Promise((resolve, reject) => {
    Rails.ajax({
      ...config,
      success: data => {
        resolve(data)
      },
    })
  })
}

const get = async (url, dataType = 'script') => {
  return await ajax({ url, type: 'GET', dataType: dataType })
}

const post = async (url, data = {}, dataType = 'script') => {
  return await ajax({ url, data: queryString(data), type: 'POST', dataType: dataType })
}

const patch = async (url, data = {}, dataType = 'script') => {
  return await ajax({ url, data: queryString(data), type: 'PATCH', dataType: dataType })
}

const remove = async (url, data = {}, dataType = 'script') => {
  return await ajax({ url, data: queryString(data), type: 'DELETE', dataType: dataType })
}

export { ajax, get, post, patch, remove }
